import { $fetch } from '@/plugins/Fetch'
/**
 * 下载中心相关接口
 * xiao_wei
 */


class VerificationAjax {
  static async HttpAjax ({ url, data }, that) {
    try {
      const { response, result } = await $fetch(url, data)
      if (response.status === 200 && result.code === 0) {
        that.$store.dispatch('showMessage', {
          type: 'success',
          title: '导出成功',
          content: '请前往下载中心查看详情',
          resolve: () => {
            that.$router.push({
              name: 'downloadList',
            })
          },
        })
      } else {
        this._exception(response, result, that)
      }
    } catch (err) {
      console.log(err)
      this._exception(err.response, err.result, that)
    }
  }
  // 封装错误信息方法
  static _exception (response, result, that) {
    let error = `（${response.status}${result && result.code ? ' ' + result.code : ''}）`
    that.$store.dispatch('showMessage', {
      type: 'failure',
      title: '请求错误',
      content: '服务异常，请稍后再试' + error,
    })
  }
}

export default {
  methods: {
    //  助力数据导出activity/help_launch_list_export
    exportHelpListApi (params) {
      return VerificationAjax.HttpAjax({
        url: `activity/help_launch_list_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 二维码数据统计导出
    exportCodeStatsTotal (params) {
      return VerificationAjax.HttpAjax({
        url: `collector/export_stats_total?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
     // 积分列表导出
    pointUseExportList (params) {
      return VerificationAjax.HttpAjax({
        url: 'point/export_list',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },
    // 二维码数据统计明细导出
    exportCodeDetailFrom (params) {
      return VerificationAjax.HttpAjax({
        url: `collector/export_stats_list?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 交易记录导出
    exportRecord (params) {
      return VerificationAjax.HttpAjax({
        url: `seckill/order_list_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 海报列表统计导出
    exportPoster (params) {
      return VerificationAjax.HttpAjax({
        url: `poster/poster_statistics_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 海报列表统计明细导出
    exportPosterDetail (params) {
      return VerificationAjax.HttpAjax({
        url: `poster/poster_statistics_detail_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 海报用户明细导出
    exportPosterCustomerDetail (params) {
      return VerificationAjax.HttpAjax({
        url: `poster/poster_customer_detail_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 客户列表导出
    exportCustomerList (params) {
      return VerificationAjax.HttpAjax({
        url: `customer/export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 订单流水导出
    exportOrderTurnover (params) {
      return VerificationAjax.HttpAjax({
        url: `order/turnover_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 订单导出
    exportOrderList (params) {
      return VerificationAjax.HttpAjax({
        url: `new_order/export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 分账导出
    exportAccountsList (params) {
      return VerificationAjax.HttpAjax({
        url: `accounts/new_list_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 平台订单结算详情列表导出
    exportAccountsCountList (params) {
      return VerificationAjax.HttpAjax({
        url: `accounts/count-list/export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 优惠券记录列表导出
    exportCouponRecord (params) {
      return VerificationAjax.HttpAjax({
        url: `marketing/coupon/record/export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 员工批量导出
    exportMember (params) {
      return VerificationAjax.HttpAjax({
        url: `member/export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 推送消息发送记录导出
    exportTaskLog (params) {
      return VerificationAjax.HttpAjax({
        url: `template_message/task_log/export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },

    // 订单核销记录导出
    exportOrderOff (params) {
      return VerificationAjax.HttpAjax({
        url: 'new_order/export_write_off_list',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },

    // 优惠券核销记录导出
    exportCouponOff (params) {
      return VerificationAjax.HttpAjax({
        url: `export/export_write_off_coupon_list?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 平台优惠券核销记录导出
    exportPlatCouponOff (params) {
      return VerificationAjax.HttpAjax({
        url: `export/export_write_off_hub_coupon_list?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },

    // 保养卡核销记录导出
    exportUpkeepOff (params) {
      return VerificationAjax.HttpAjax({
        url: `export/export_write_off_upkeep_list?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },

    // 活动管理导出报名用户
    exportActivityCustomer (params) {
      return VerificationAjax.HttpAjax({
        url: `activity/activity_customer_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },

    // 活动管理导出报名用户（模板活动）
    exportActivityCustomerTemplate (params) {
      return VerificationAjax.HttpAjax({
        url: `activity/activity_customer_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },

    // 活动管理导出员工数据统计（模板活动）
    exportActivityStatisticMember (params) {
      return VerificationAjax.HttpAjax({
        url: `activity_store/member_statistic_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },

    // 活动管理导出订单
    exportActivityOrder (params) {
      return VerificationAjax.HttpAjax({
        url: `activity/activity_order_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },

    // 导出车检意向池
    exportInspectApi (params) {
      return VerificationAjax.HttpAjax({
        url: 'inspect/export_intention_list',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },

    // 导出养护卡使用数据
    exportCardApi (params) {
      return VerificationAjax.HttpAjax({
        url: `upkeep/sale_list_export?${params}`,
        data: {
          method: 'GET',
          body: {},
        },
      }, this)
    },
    // 下载录单详情
    exportRecBatchApi (params) {
      return VerificationAjax.HttpAjax({
        url: 'new_order/order_batch_record/export_batch_item',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },
    // 下载录单详情
    exportRechargeRecApi (params) {
      return VerificationAjax.HttpAjax({
        url: 'balance/recharge_list_export',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },
    // 余额充值 - 交易明细列表导出
    exportBalanceTransRecApi (params) {
      return VerificationAjax.HttpAjax({
        url: 'balance/consume_list_export',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },
    // 导出邀新记录汇总列表
    exportInvation (params) {
      return VerificationAjax.HttpAjax({
        url: 'invite_new/stats/export_record_summary',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },
    // 导出邀请明细列表
    exportDetails (params) {
      return VerificationAjax.HttpAjax({
        url: 'invite_new/stats/export_record_detail',
        data: {
          method: 'POST',
          body: params,
        },
      }, this)
    },

  },
}



// WEBPACK FOOTER //
// ./src/mixins/modules/export.js